/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';
import type { SuiviSiegeLieuGridDto } from './SuiviSiegeLieuGridDto';
import {
    SuiviSiegeLieuGridDtoFromJSON,
    SuiviSiegeLieuGridDtoFromJSONTyped,
    SuiviSiegeLieuGridDtoToJSON,
} from './SuiviSiegeLieuGridDto';

/**
 * 
 * @export
 * @interface SuiviSiegeLieuGridDtoPaginatedResults
 */
export interface SuiviSiegeLieuGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof SuiviSiegeLieuGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<SuiviSiegeLieuGridDto>}
     * @memberof SuiviSiegeLieuGridDtoPaginatedResults
     */
    results?: Array<SuiviSiegeLieuGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof SuiviSiegeLieuGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the SuiviSiegeLieuGridDtoPaginatedResults interface.
 */
export function instanceOfSuiviSiegeLieuGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SuiviSiegeLieuGridDtoPaginatedResultsFromJSON(json: any): SuiviSiegeLieuGridDtoPaginatedResults {
    return SuiviSiegeLieuGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function SuiviSiegeLieuGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SuiviSiegeLieuGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(SuiviSiegeLieuGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function SuiviSiegeLieuGridDtoPaginatedResultsToJSON(value?: SuiviSiegeLieuGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(SuiviSiegeLieuGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

